import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { metaReducer } from "./metaReducer";
import seoRedirects from "./seoRedicrect";

const allReducers = combineReducers({
	auth: userReducer,
	meta: metaReducer,
	seoRedirects,
});

export default allReducers;
